import styled from 'styled-components'
import { COLOR, SPACING, TEXT } from 'app-v2/design-tokens'
import { colors } from 'app-v2/design-systems'

export const StyledDropdownItem = styled.li`
    padding: ${SPACING.XXS} ${SPACING.S};
    font-family: ${TEXT.FONT_FAMILY.DEFAULT_SANS};
    color: ${COLOR.PRIMARY};
    font-size: ${TEXT.FONT_SIZE.M};
    cursor: pointer;
    &:hover {
        background: ${colors.lightGrey};
    }
`

export const StyledStockText = styled.text`
    font-family: ${TEXT.FONT_FAMILY.DEFAULT_SANS};
    text-align: center;
`
